import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
  Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../services/authService';
import { clearUser } from '../userSlice';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import BusinessIcon from '@mui/icons-material/Business';

export default function OnboardingHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = async () => {
    try {
      await logout();
      dispatch(clearUser());
      navigate('/login');
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <AppBar position="static" elevation={1}>
      <Toolbar>
        {/* Logo/Brand */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              color="inherit"
              startIcon={<HomeIcon />}
              sx={{ textTransform: 'none', fontSize: '1.25rem' }}
              disabled
            >
              Meeting Rooms
            </Button>
            
            {/* Organization Name */}
            {user?.organization && !isMobile && (
              <Chip
                icon={<BusinessIcon />}
                label={user.organization.name}
                size="small"
                variant="outlined"
                sx={{ 
                  color: 'white', 
                  borderColor: 'white',
                  ml: 1
                }}
              />
            )}
          </Box>
        </Typography>

        {/* User Info & Actions */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? 1 : 2 }}>
          {/* User name */}
          {user && !isMobile && (
            <Typography variant="body2" sx={{ color: 'white', opacity: 0.9 }}>
              Welcome, {user.username}
            </Typography>
          )}
          
          {/* Logout Button */}
          <Button
            color="inherit"
            onClick={handleLogout}
            startIcon={!isMobile ? <LogoutIcon /> : null}
            variant="outlined"
            sx={{ 
              color: 'white',
              borderColor: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderColor: 'white',
              }
            }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
} 